// @flow

import type { State } from './State';

/**
 * Gets the initial value for the theme
 *
 * @returns {string}
 */
function getTheme(): ?string {
  let theme: ?string = 'default';
  const meta = document.querySelector('meta[name="xtime:theme"]');
  if (meta) {
    theme = meta.getAttribute('content');
  }
  return theme;
}

const initialState: State = {
  form: null,
  router: null,
  alert: false,
  ajaxCall: {
    stack: [],
    binnacle: []
  },
  deeplink: {
    navigation: '/',
    kind: null,
    verifiedVehicle: false,
    incompleteVehicle: false,
    apptRevisit: false,
    isDeeplink: false,
    isDeeplinking: false,
    hasServices: false
  },
  login: {},
  marketing: {
    urlOptIn: '',
    isDefaultPromotionSet: false
  },
  promotion: null,
  userInteractions: {
    privateRoute: false,
    isLoadingAppointment: false,
    whoami: 'CP8',
    channel: '3',
    appFlow: '',
    appName: '',
    recaptchaToken: '',
    quickAppointment: {
      isQuickApptEnabled: false,
      localizedQuickApptService: ''
    },
    pageVehicle: {
      noFindsAlertShown: false,
      showMobileFooter: false,
      vehiclePageRevisit: false,
      // TODO (Miguel): workaround move this to an entity
      trimsSelectedPosition: null
    },
    pageAppointment: {
      gtmFirstAvailableTimeslot: null,
      selectedDay: null,
      filterDaysBy: null,
      noLongerAvailableDate: false,
      lastTimeslotSelected: null,
      selectedTimeslotInPromoRange: null
    },
    pageReview: {
      contactInfoMissing: false
    },
    modifyEnabled: false,
    apptModified: false,
    startEventSent: false,
    populateMobilePhoneNumber: true,
    searchCriteriaFindMe: '',
    contactInfoFormValid: false,
    guid: null,
    setSavedMobile: null
  },
  tokenId: 0,
  queryParams: null,
  availableTimes: null,
  firstAvailableTimeSlot: {},
  dealerLocale: {
    locale: '',
    countryCode: '',
    languageCode: ''
  },
  dealerData: {
    dealerLocalization: {}
  },
  dealerSettings: null,
  declined: [],
  maintenance: [],
  repair: [],
  globalRepair: [],
  recall: [],
  deferred: [],
  packages: {
    servicePoints: [],
    useExactMileageFlag: 0
  },
  errors: {
    services: {
      errorPackages: false,
      errorRepair: false,
      errorMaintenance: false,
      errorRecall: false,
      errorDeclined: false
    },
    dayTime: false,
    apptOption: false,
    externalValetLoaner: ''
  },
  apptOptions: {},
  appointment: {
    contactInfo: {
      phone: '',
      mobilePhone: '',
      email: '',
      obfuscatedBy: null,
      extId: null
    },
    vehicle: {
      mileage: null,
      regDate: null
    },
    startTime: null,
    teamIds: null,
    attendanceStatus: 'new',
    autoRecallServices: [],
    declinedServices: [],
    recallServices: [],
    services: [],
    maintenanceServices: [],
    repairServices: [],
    servicePoint: null,
    advisorId: null,
    isCarryOver: false,
    isDmsAppt: false,
    isQuoteAppt: false,
    privacySettings: {
      emailPrivacySetting: '0,X,X,X,X,X,X',
      textPrivacySetting: '0,X,X,X,X,X,0'
    },
    reservationStatusPrivacySettings: {
      emailPrivacySetting: 'X,X,X,X,X,X,0',
      textPrivacySetting: 'X,X,X,X,X,X,0'
    },
    callBack: false,
    valetDetails: {
      comments: '',
      externalValetProvider: '',
      dropoffPreference: ''
    }
  },
  years: [],
  models: [],
  trims: {},
  customerVehicles: [],
  // @TODO improve
  localizationString: {},
  navigation: {
    isNavigating: false,
    currentPath: '/',
    previousPath: null,
    direction: null
  },
  ui: {
    theme: getTheme()
  },
  user: {
    personInfo: null,
    social: {}
  },
  quoteAppt: {
    isQuoteAppt: false,
    showError: false,
    readOnlyServices: [],
    readOnlyPackage: {}
  },
  states: [],
  statusTracker: {},
  selfCheckIn: {
    checkIn: {
      reservationId: null,
      selfCheckinWaitState: '',
      personId: null,
      selfCheckinMileage: null,
      selfCheckinSigned: 'N',
      selfCheckinStatus: '',
      hasAdditionalServices: false,
      licensePlate: '',
      vehicleColor: ''
    },
    configFlow: {
      additionalServices: '',
      additionalServicesNotes: '',
      selfCheckInFlow: '',
      isNavigating: false,
      isDealerOpenNow: false,
      initialLoadingComplete: false
    }
  },
  optimizelyABTest: {
    CP8: {
      CTABanner: {
        topCTA: 'rounded',
        hideBottomCTA: false,
        showProgressBar: true,
        backButton: 'classic'
      },
      bookItButton: {
        showBookItButtonLabel: false
      }
    },
    SCI: {
      showProgressBar: false
    }
  },
  scripts: []
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/initialState.js